module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAMAAABlGZcgAAAAUVBMVEVHcEwLV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88xlK+dAAAAGnRSTlMAS/mX8cwzD8M8Qwsk5J58dC0E3s20XsYDfRf9LaYAAABtSURBVHjajcvLEoMgEETRZjBBAaPxmfT/f6gMFQvNwvLuTvUMsDxKc4QTHprhWD33FtZq7DXF3p9NXtgyZ/59819t7dkxHP3pZfTFcWXKhp97YWs64fjNTr0c8J7I7DRCGzpR65jTkxrBoDSYDdc2DCD/f59NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_qd.png
// module id = EZxi
// module chunks = 1